module.exports = __webpack_public_path__ + "img/selfDvl.e703c926.svg";